import { useQuery } from '@tanstack/react-query';
import { DECKS_PER_PAGE } from 'constants/itemsPerPage';
import useApi from 'hooks/useApi';
import useUserApi from 'hooks/UserApi/useUserApi';
import { useRouter } from 'next/router';
import deckFactory from 'utils/factories/decks';

export const useDecksDetails = (id?: string | null) => {
  const queryKey = deckFactory.details(id || '');
  const apiClient = useApi();

  const queryResult = useQuery({
    queryKey,
    queryFn: () => apiClient.deckUserLists.apiDeckUserListsIdGet(id as string),
    select: (res) => res.data,
    enabled: !!id,
  });

  return { queryResult, queryKey };
};

export const useDeckStats = (id?: string | null) => {
  const queryKey = deckFactory.deckStats(id || '');
  const apiClient = useApi();

  return {
    queryResult: useQuery({
      queryKey,
      queryFn: () => apiClient.deckUserLists.apiDeckUserListsIdstatsGet(id as string),
      select: (v) => v.data,
      enabled: !!id,
    }),
    queryKey,
  };
};

type DeckListProps = { isLegal?: boolean };

export const useDeckListApi = (param?: DeckListProps) => {
  const apiClient = useApi();
  const {
    query: { page, slug, ...filters },
  } = useRouter();
  const { userId } = useUserApi();

  const decksListFilters = {
    user: userId,
    'order[createdAt]': 'desc' as 'asc' | 'desc',
    ...filters,
    ...param,
  };

  const queryKey = deckFactory.list({
    page: typeof page === 'string' ? page.toString() : '1',
    itemsPerPage: DECKS_PER_PAGE.toString(),
    ...decksListFilters,
  });

  const queryResult = useQuery({
    queryKey,
    queryFn: async () =>
      apiClient.deckUserLists.apiDeckUserListsGetCollection({
        page: typeof page === 'string' ? parseInt(page, 10) : 1,
        itemsPerPage: DECKS_PER_PAGE,
        ...decksListFilters,
      }),
    select: (res) => res.data,
    enabled: !!userId,
  });

  return { queryResult };
};
